import { convertDateToUSFormat } from "./date.js";
const requiredValidator = {
  attribute: "required",
  key: "valueMissing",
  isValid(instance, value) {
    let valid = true;
    if ((instance.hasAttribute("required") || instance.required) && !value) {
      valid = false;
    }
    return valid;
  }
};
const customValidator = {
  attribute: "error",
  key: "customError",
  isValid(instance) {
    return !instance.error;
  }
};
const minLengthValidator = {
  attribute: "minlength",
  key: "rangeUnderflow",
  isValid(instance, value) {
    if (value && instance.minLength > value.length) {
      return false;
    }
    return true;
  }
};
const maxLengthValidator = {
  attribute: "maxlength",
  key: "rangeOverflow",
  isValid(instance, value) {
    if (!instance.maxLength) {
      return true;
    }
    if (!!value && instance.maxLength < value.length) {
      return false;
    }
    return true;
  }
};
const patternValidator = {
  attribute: "pattern",
  key: "patternMismatch",
  isValid(instance, value) {
    if (!value || !instance.pattern) {
      return true;
    }
    let regExp = new RegExp(instance.pattern);
    const flags = regExp.flags.includes("g") ? regExp.flags : regExp.flags + "g";
    regExp = new RegExp(regExp, flags);
    const match = regExp.exec(value);
    return !!match && (match == null ? void 0 : match.input) === (match == null ? void 0 : match[0]);
  }
};
const validateEmail = (email) => {
  const format = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return email.match(format);
};
const emailValidator = {
  attribute: "email",
  key: "typeMismatch",
  isValid(instance, value) {
    if (!value || instance.type !== "email") {
      return true;
    }
    return !!validateEmail(value);
  }
};
const validateURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};
const urlValidator = {
  attribute: "url",
  key: "badInput",
  isValid(instance, value) {
    if (!value || instance.type !== "url") {
      return true;
    }
    return validateURL(value);
  }
};
const isDateInputValid = (instance, value, attr) => {
  const date = instance.getAttribute(attr);
  const convertedTarget = instance.getAttribute("format") === "universal" ? convertDateToUSFormat(value) : value;
  const convertedDate = date ? convertDateToUSFormat(date) : "";
  return attr === "min-date" ? !date || new Date(convertedTarget).getTime() >= new Date(convertedDate).getTime() : !date || new Date(convertedTarget).getTime() <= new Date(convertedDate).getTime();
};
const minDateValidator = {
  attribute: "min-date",
  key: "rangeUnderflow",
  isValid(instance, value) {
    if (!value || !instance.hasAttribute("min-date")) {
      return true;
    }
    return isDateInputValid(instance, value, "min-date");
  }
};
const maxDateValidator = {
  attribute: "max-date",
  key: "rangeOverflow",
  isValid(instance, value) {
    if (!value || !instance.hasAttribute("max-date")) {
      return true;
    }
    return isDateInputValid(instance, value, "max-date");
  }
};
export {
  customValidator,
  emailValidator,
  maxDateValidator,
  maxLengthValidator,
  minDateValidator,
  minLengthValidator,
  patternValidator,
  requiredValidator,
  urlValidator
};
//# sourceMappingURL=validators.js.map
